import './skeleton.scss';

const Skeleton = ({children, className = ''}) => {

  return (
    <span className={'skeleton ' + className}>{children}</span>
  )
}

export { Skeleton };